import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { friendlyAuthMessage } from '../auth/cognitoError';
import { useAuth } from '../auth/useAuth';
import { AuthScreen, Button, ErrorText, TextField, VideoBackdrop } from '../components/ui';

export function Login() {
  const { signIn, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
      navigate('/overview', { replace: true });
    } catch (err) {
      setError(friendlyAuthMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <VideoBackdrop />
      <AuthScreen transparent>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <p className="eyebrow">Together with their families</p>
          <h1
            className="serif"
            style={{ fontSize: '3rem', fontWeight: 500, margin: '10px 0 0', lineHeight: 1.05 }}
          >
            Lynne
            <br />
            <span
              className="serif"
              style={{ fontStyle: 'italic', fontSize: '1.6rem', color: 'var(--text-dim)' }}
            >
              and
            </span>
            <br />
            Andi
          </h1>
        </div>

        <form onSubmit={onSubmit}>
          <TextField
            label="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            label="Password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <ErrorText>{error}</ErrorText>
          <Button type="submit" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>

        <div style={{ margin: '14px 0' }}>
          <Button variant="frosted" type="button" onClick={() => void signInWithGoogle()}>
            Continue with Google
          </Button>
        </div>

        <p style={{ textAlign: 'center', color: 'var(--text-dim)', fontSize: 14, marginTop: 8 }}>
          New here? <Link to="/signup">Create an account</Link>
        </p>
      </AuthScreen>
    </>
  );
}
